import React from 'react';
import './styles.scss';

const UserName = ({ name:{firstName,lastName}, isCurrent,...props }) => {
	return (
		<div className="user__name">
            {isCurrent && <span>Hi, </span>}
			<p className="user__name-text">
				{firstName}
			</p> 
			<p className="user__name-text">
				{lastName}
			</p>
		</div>
	)
};

export default UserName;
